import React, {useCallback, useState} from 'react'

import {topicIssues} from 'constants/topicIssues'
import SelectForHelpSupport from 'components/CommonUI/SelectForHelpSupport/SelectForHelpSupport'


const SelectTopic = ({onChange}) => {

    const [value, setValue] = useState(topicIssues[0])

    const _handleChange = useCallback((value) => {
        setValue(value)
        onChange('topic', value.value)
    }, [onChange])

    return (
        <SelectForHelpSupport
            label="Select a topic"
            dataList={topicIssues}
            handleChange={_handleChange}
            selectedValue={value}
        />
    )
}

export default SelectTopic